export default {"src":"/_next/static/media/ChatGPT-Logo.38d90e16.svg","height":320,"width":320,"blurWidth":0,"blurHeight":0};